import {
	getController,
	type HpRequestOptional,
	type HpRequestPostPut,
	apiService as Service,
} from '@/services/service'

const url = 'notes'

export type NoteIndexScope = 'all' | 'invalid' | 'unread'

export const notesService = {
	...getController<Api.Note, Api.NotePostInput, Api.NotePostInput>(url),
	indexScope: (scope: NoteIndexScope, data?: HpRequestOptional) =>
		Service.get({
			url: `${url}?scope=${scope}&of=created_at&od=DESC`,
			...data,
		}),
	update: (id: number, data: HpRequestPostPut<Api.NotePostInput>) =>
		Service.put<Api.Note>({
			url: `${url}/${id}`,
			...data,
		}),
}

export default notesService
